/*
 * @Author: your name
 * @Date: 2022-03-08 08:50:12
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-06 16:21:26
 * @Description: file content
 */
import Vue from "vue";
import App from "./App.vue";
import MasonryWall from '@yeger/vue2-masonry-wall'


// import "./registerServiceWorker"; // pwa以后再说
import router from "./router";
import store from "./store";
import "@/permission"; // 权限控制
import "tailwindcss/tailwind.css";
import "./directive";
import { Lazyload, Cell, CellGroup, Image as VanImage, Loading, Button, Overlay, Notify, Grid, GridItem, Icon, Search, Toast, Dialog, Field, DatetimePicker, Popup, Form } from 'vant'
import dayjs from "dayjs";
import _ from "lodash";
import wxjs from "weixin-js-sdk";
import "@/views/AlipayInWeixin/ap.js";
import * as tools from "@/utils/index";
import VueLuckyCanvas from "@lucky-canvas/vue";

Vue.config.productionTip = false;
dayjs.extend(require("dayjs/plugin/utc"));
Vue.prototype.dayjs = dayjs;
Vue.prototype._ = _;
Vue.prototype.wxjs = wxjs;
Vue.prototype.tools = tools;
Vue.prototype.$toast = Toast;
Vue.use(Lazyload);
Vue.use(VueLuckyCanvas);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(VanImage);
Vue.use(Loading);
Vue.use(Button);
Vue.use(Overlay);
Vue.use(Notify);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Icon)
Vue.use(Dialog)
Vue.use(Field)
Vue.use(DatetimePicker)
Vue.use(Popup)
Vue.use(Form)

Vue.use(MasonryWall)
Vue.use(Search)
import "./custom.less"; //自定义的一些样式

Vue.filter("amount", (val) => {
  return Number(val).toFixed(2);
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");


